/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */
import React, { useRef, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import api from '../../../../../services/api';

import getValidationErrors from '../../../../../utils/getValidationError';
import { useToast } from '../../../../../context/ToastContext';

import Loading from '../../../../../components/Loading';
import Input from '../../../../../components/Input';
import Button from '../../../../../components/Button';

import { Container, Content } from './styles';

import { IManufacturing } from '../../../../../interfaces/manufacturing';

const CreateManufacturing: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const navigate = useNavigate();
  const { addToast } = useToast();

  const [saving, setSaving] = useState<boolean>(false);

  const handleFormSubmit = useCallback(
    async (dataForm: IManufacturing, { reset }) => {
      try {
        setSaving(true);

        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required('O Nome do Material é obrigatório'),
        });

        await schema.validate(dataForm, { abortEarly: false });

        await api.post('manufacturing/steps', dataForm);

        addToast({
          type: 'success',
          title: 'Cadastro realizado com sucesso',
        });

        reset();
        setSaving(false);

        navigate('/manufacturing/steps');
      } catch (error: any) {
        setSaving(false);

        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErrors(error);
          formRef.current?.setErrors(errors);

          return;
        }

        if (error.response) {
          const { data } = error.response; // Error vindo do back está em data dentro de response

          addToast({
            type: 'error',
            title: 'Erro no cadastro',
            description: data.message,
          });
          if (
            formRef.current?.getFieldRef(data.field) &&
            data.field.toString().indexOf('_id') === -1
          ) {
            formRef.current?.getFieldRef(data.field).focus(); // Foca o campo que deu erro de acordo com o field retornado do back
          }

          return;
        }

        addToast({
          type: 'error',
          title: 'Error',
          description: 'Erro ao cadastrar!',
        });
      }
    },
    [addToast, navigate],
  );

  return (
    <Container>
      <Content>
        <header>
          <p>Cadastro de Etapa</p>
        </header>
        <Form ref={formRef} onSubmit={handleFormSubmit}>
          <div>
            <Input
              id="name"
              name="name"
              type="text"
              labelText="Nome*"
              maxLength={22}
              disabled={saving}
            />
          </div>

          <Button type="submit" style={{ width: '233px' }} disabled={saving}>
            {saving ? <Loading size={24} color="white" /> : 'Salvar'}
          </Button>
        </Form>
      </Content>
    </Container>
  );
};

export default CreateManufacturing;
